/**
 * A class representing a date without time information.
 */
export class DateOnly {
  private constructor(
    readonly year: number,
    readonly month: number,
    readonly day: number,
  ) {}

  /**
   * Creates a DateOnly instance from a Date object.
   * @param d - The Date object to extract the date from.
   * @returns A DateOnly instance representing the date portion of the Date object.
   */
  static fromDate(d: Date): DateOnly {
    return new DateOnly(d.getFullYear(), d.getMonth() + 1, d.getDate());
  }

  static parse(iso: string): DateOnly {
    const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(iso);
    if (!m) {
      throw new Error('Invalid DateOnly');
    }

    return new DateOnly(+m[1], +m[2], +m[3]);
  }

  toDate(): Date {
    return new Date(this.year, this.month - 1, this.day);
  }

  /**
   * Converts the DateOnly instance to a JSON string. This method is called automatically
   * when using JSON.stringify().
   *
   * @returns A JSON string representation of the DateOnly instance.
   */
  toJSON(): string {
    return this.toString();
  }

  toString(): string {
    return `${this.year}-${String(this.month).padStart(2, '0')}-${String(this.day).padStart(2, '0')}`;
  }
}
